import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const HigashikawaHero = () => {
  return (
    <section className="relative min-h-[80vh] flex items-center pt-20 pb-16 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=1600&h=900&fit=crop&q=80" 
          alt="北海道東川町風景" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-950/90 via-teal-900/70 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl text-white space-y-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full text-sm font-medium border border-white/30"
          >
            <SafeIcon name="MapPin" />
            <span>日本北海道・大雪山腳下</span>
          </motion.div>

          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight"
          >
            相信世代海外見學 <br/>
            <span className="text-teal-300">@東川町</span>
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl md:text-2xl font-medium text-gray-200 border-l-4 border-teal-400 pl-4 py-1"
          >
            見學夥伴招募中！<br/>
            一起去探索 #全日本最宜居 的地方吧！
          </motion.div>

          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg text-gray-300 leading-relaxed max-w-2xl pt-4"
          >
            這是一個位於北海道大雪山腳下，人口僅 8,000 多人的小鎮。它如何在 40 年間華麗轉身，成為無數日本人心中理想移居的地方？讓我們親臨現場，尋找地域重生的答案。
          </motion.p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="pt-6 flex flex-wrap gap-4"
          >
            <a href="#schedule" className="btn-primary px-8">查看梯次與報名</a>
            <a href="https://youtu.be/bc2JMStc4FU" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-full text-white hover:bg-white hover:text-teal-900 transition-colors duration-300 gap-2">
              <SafeIcon name="PlayCircle" />
              觀看前導影片
            </a>
          </motion.div>
        </div>
      </div>
      
      {/* Scroll Down Indicator */}
      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70"
      >
        <SafeIcon name="ChevronDown" className="w-8 h-8" />
      </motion.div>
    </section>
  );
};

export default HigashikawaHero;